import { useCallback, useEffect, useState } from "react";
import {
   isLessonBookingWindowOpen,
   isPracticalExamBookingWindowOpen,
} from "../utils/studentBookingWindow";

/**
 * Ține starea „fereastra de programare e deschisă” pentru un ecran de elev.
 * `isWindowOpen` decide intervalul (lecții vs examen practic), pentru că cele
 * două se închid la ore diferite.
 */
export function useStudentBookingWindow(isWindowOpen, pollMs = 30000) {
   const [bookingWindowOpen, setBookingWindowOpen] = useState(() =>
      isWindowOpen(),
   );

   const refreshBookingWindow = useCallback(() => {
      setBookingWindowOpen(isWindowOpen());
   }, [isWindowOpen]);

   useEffect(() => {
      refreshBookingWindow();
      const intervalId = window.setInterval(refreshBookingWindow, pollMs);
      const onVisibilityChange = () => {
         if (document.visibilityState === "visible") refreshBookingWindow();
      };
      document.addEventListener("visibilitychange", onVisibilityChange);
      return () => {
         window.clearInterval(intervalId);
         document.removeEventListener("visibilitychange", onVisibilityChange);
      };
   }, [pollMs, refreshBookingWindow]);

   return { bookingWindowOpen, refreshBookingWindow };
}

export function usePracticalExamBookingWindow(pollMs) {
   return useStudentBookingWindow(isPracticalExamBookingWindowOpen, pollMs);
}

export function useLessonBookingWindow(pollMs) {
   return useStudentBookingWindow(isLessonBookingWindowOpen, pollMs);
}
